export default __webpack_public_path__ + "static/media/resonance3.dcebfa76.png";